import React from 'react';
import FormROValue from '../../../library/form/components/FormROValue1';

const InvTaxBreakupRow = (props) => {
    const { formObject, rowKey } = props;
    return (
        <ul>
            <li className="uiColumnCenter uiColumn70">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "taxAmtFormula" }} className='uiVal' />
            </li>
            <li className="uiColumnCenter uiColumn70">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "taxDesc" }} className='uiVal' />
            </li>
            <li className="uiColumnCenter uiColumn70">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "baseAmt" }} className='uiVal' />
            </li>
            <li className="uiColumnCenter uiColumn70">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "taxAmt" }} className='uiVal' />
            </li>
        </ul>
    )
}

export default InvTaxBreakupRow